unit DieselAttendants;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons,
  Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCBitmapContainer,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, VCL.TMSFNCEdit;

type
  TfrmFuelAttendants = class(TForm)
    pnlAttendants: TPanel;
    WebPanel1: TPanel;
    pnlNavigator: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebPanel2: TPanel;
    WebButton1: TButton;
    dgAttendants: TTMSFNCDataGrid;
    wcFuelAttendants: TXDataWebClient;
    wdsFuelAttendants: TXDataWebDataSet;
    dsFuelAttendants: TDataSource;
    dbaFuelAttendants: TTMSFNCDataGridDatabaseAdapter;
    BitmapContainer: TTMSFNCBitmapContainer;
    wdsFuelAttendantsATTNO: TIntegerField;
    wdsFuelAttendantsNAME: TStringField;
    wdsFuelAttendantspassword: TStringField;
    wdsFuelAttendantsSUSPENDED: TBooleanField;
    sbtnPCFirst: TSpeedButton;
    sbtnPCPrior: TSpeedButton;
    sbtnPCNext: TSpeedButton;
    sbtnPCLast: TSpeedButton;
    edtAttendantPC: TTMSFNCEdit;
    msgdlgFuelAttendants: TMessageDlg;
    procedure WebFormShow(Sender: TObject);
    procedure sbtnPCFirstClick(Sender: TObject);
    procedure sbtnPCPriorClick(Sender: TObject);
    procedure sbtnPCNextClick(Sender: TObject);
    procedure sbtnPCLastClick(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure dgAttendantsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgAttendantsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
  private
    { Private declarations }
    iAttendantsMaxPC, iAttendantsPC : Integer;

    procedure LoadFuelAttendants;
  public
    { Public declarations }

  protected procedure LoadDFMValues; override; end;

var
  frmFuelAttendants: TfrmFuelAttendants;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common, DieselAttendantSetup;

{ TfrmFuelAttendants }

procedure TfrmFuelAttendants.dgAttendantsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
  newform : TfrmDieselAttendantSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          iAttno := dbaFuelAttendants.FieldAtColumn[0].AsInteger;
        end;
    end;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadFuelAttendants;
    end;

  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          dbaFuelAttendants.SetActiveRecord(Arow);
          wcFuelAttendants.RawInvoke('IstfmsdieselService.Put_FuelAttendant_Delete',[dbaFuelAttendants.FieldAtColumn[0].AsInteger]);

          LoadFuelAttendants;
        End
      else
        Exit;
    end;

begin

  if AColumn = 4 then
    Begin
      newform := TfrmDieselAttendantSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal(@AfterShowModal);
    End;

  if AColumn = 5 then
    Begin
      msgdlgFuelAttendants.ShowDialog('Do you want to delete this record', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End

end;

procedure TfrmFuelAttendants.dgAttendantsGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dbaFuelAttendants.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 4 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer.BitmapNames[1];
      if ACell.Column = 5 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer.BitmapNames[0];
    end;
end;

procedure TfrmFuelAttendants.LoadFuelAttendants;
  procedure OnResultError(Error: TXDataClientError);
    begin
      LoadFuelAttendants;
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      edtAttendantPC.Text := IntToStr(iAttendantsPC) + ' OF ' + IntToStr(iAttendantsMaxPC);

      wdsFuelAttendants.Close;
      wdsFuelAttendants.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsFuelAttendants.Open;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadFuelAttendants;
        end
      else
        begin
          iAttendantsMaxPC := Integer(TJSObject(Response.Result)['value']);

          wcFuelAttendants.RawInvoke('IstfmsdieselService.Get_FuelAttendants_View',[iAttendantsPC,0],@OnResultNumbers,@OnResultError);
        end;
    end;
begin
  wcFuelAttendants.RawInvoke('IstfmsdieselService.Get_FuelAttendant_MaxPC',[],@OnResultPC,@OnResultError);
end;

procedure TfrmFuelAttendants.sbtnPCFirstClick(Sender: TObject);
begin
  iAttendantsPC := 1;
  LoadFuelAttendants;
end;

procedure TfrmFuelAttendants.sbtnPCLastClick(Sender: TObject);
begin
  iAttendantsPC:= iAttendantsMaxPC;
  LoadFuelAttendants;
end;

procedure TfrmFuelAttendants.sbtnPCNextClick(Sender: TObject);
begin
 if iAttendantsPC < iAttendantsMaxPC then
  Begin
    iAttendantsPC := iAttendantsPC + 1;
    LoadFuelAttendants;
  End;

end;

procedure TfrmFuelAttendants.sbtnPCPriorClick(Sender: TObject);
begin
  if iAttendantsPC > 1 then
    Begin
      iAttendantsPC := iAttendantsPC - 1;
      LoadFuelAttendants;
    End;
end;

procedure TfrmFuelAttendants.WebFormShow(Sender: TObject);
begin
  iAttendantsPC := 1;


  LoadFuelAttendants;
end;

procedure TfrmFuelAttendants.WebSpeedButton1Click(Sender: TObject);
begin
  wdsFuelAttendants.First;
end;

procedure TfrmFuelAttendants.WebSpeedButton2Click(Sender: TObject);
begin
 wdsFuelAttendants.Prior;
end;

procedure TfrmFuelAttendants.WebSpeedButton3Click(Sender: TObject);
begin
  wdsFuelAttendants.Next;
end;

procedure TfrmFuelAttendants.WebSpeedButton4Click(Sender: TObject);
begin
  wdsFuelAttendants.Last;
end;

procedure TfrmFuelAttendants.WebSpeedButton5Click(Sender: TObject);
var
  newform : TfrmDieselAttendantSetup;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadFuelAttendants;
    end;

begin
  newform := TfrmDieselAttendantSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.Showmodal(@AfterShowModal);
end;

procedure TfrmFuelAttendants.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlAttendants := TPanel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  BitmapContainer := TTMSFNCBitmapContainer.Create(Self);
  msgdlgFuelAttendants := TMessageDlg.Create(Self);
  pnlNavigator := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  sbtnPCFirst := TSpeedButton.Create(Self);
  sbtnPCPrior := TSpeedButton.Create(Self);
  sbtnPCNext := TSpeedButton.Create(Self);
  sbtnPCLast := TSpeedButton.Create(Self);
  edtAttendantPC := TTMSFNCEdit.Create(Self);
  dgAttendants := TTMSFNCDataGrid.Create(Self);
  dbaFuelAttendants := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcFuelAttendants := TXDataWebClient.Create(Self);
  wdsFuelAttendants := TXDataWebDataSet.Create(Self);
  wdsFuelAttendantsATTNO := TIntegerField.Create(Self);
  wdsFuelAttendantsNAME := TStringField.Create(Self);
  wdsFuelAttendantspassword := TStringField.Create(Self);
  wdsFuelAttendantsSUSPENDED := TBooleanField.Create(Self);
  dsFuelAttendants := TDataSource.Create(Self);

  pnlAttendants.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  BitmapContainer.BeforeLoadDFMValues;
  msgdlgFuelAttendants.BeforeLoadDFMValues;
  pnlNavigator.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  sbtnPCFirst.BeforeLoadDFMValues;
  sbtnPCPrior.BeforeLoadDFMValues;
  sbtnPCNext.BeforeLoadDFMValues;
  sbtnPCLast.BeforeLoadDFMValues;
  edtAttendantPC.BeforeLoadDFMValues;
  dgAttendants.BeforeLoadDFMValues;
  dbaFuelAttendants.BeforeLoadDFMValues;
  wcFuelAttendants.BeforeLoadDFMValues;
  wdsFuelAttendants.BeforeLoadDFMValues;
  wdsFuelAttendantsATTNO.BeforeLoadDFMValues;
  wdsFuelAttendantsNAME.BeforeLoadDFMValues;
  wdsFuelAttendantspassword.BeforeLoadDFMValues;
  wdsFuelAttendantsSUSPENDED.BeforeLoadDFMValues;
  dsFuelAttendants.BeforeLoadDFMValues;
  try
    Name := 'frmFuelAttendants';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlAttendants.SetParentComponent(Self);
    pnlAttendants.Name := 'pnlAttendants';
    pnlAttendants.Left := 0;
    pnlAttendants.Top := 0;
    pnlAttendants.Width := 640;
    pnlAttendants.Height := 480;
    pnlAttendants.Align := alClient;
    pnlAttendants.TabOrder := 0;
    WebPanel1.SetParentComponent(pnlAttendants);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 60;
    WebPanel1.Align := alTop;
    WebPanel1.Caption := 'Fuel Attendants';
    WebPanel1.Color := clSilver;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -16;
    WebPanel1.Font.Name := 'Segoe UI';
    WebPanel1.Font.Style := [fsBold];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 0;
    BitmapContainer.SetParentComponent(WebPanel1);
    BitmapContainer.Name := 'BitmapContainer';
    BitmapContainer.Left := 520;
    BitmapContainer.Top := 3;
    BitmapContainer.Width := 26;
    BitmapContainer.Height := 26;
    BitmapContainer.Visible := True;
    BitmapContainer.Items.Clear;
    with BitmapContainer.Items.Add do
    begin
      Bitmap.LoadFromFile('DieselAttendants.BitmapContainer.Items.Bitmap.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    with BitmapContainer.Items.Add do
    begin
      Bitmap.LoadFromFile('DieselAttendants.BitmapContainer.Items.Bitmap_1.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    msgdlgFuelAttendants.SetParentComponent(WebPanel1);
    msgdlgFuelAttendants.Name := 'msgdlgFuelAttendants';
    msgdlgFuelAttendants.Left := 440;
    msgdlgFuelAttendants.Top := 16;
    msgdlgFuelAttendants.Width := 24;
    msgdlgFuelAttendants.Height := 24;
    msgdlgFuelAttendants.Buttons := [];
    msgdlgFuelAttendants.Opacity := 0.200000000000000000;
    pnlNavigator.SetParentComponent(pnlAttendants);
    pnlNavigator.Name := 'pnlNavigator';
    pnlNavigator.Left := 0;
    pnlNavigator.Top := 60;
    pnlNavigator.Width := 640;
    pnlNavigator.Height := 55;
    pnlNavigator.Align := alTop;
    pnlNavigator.ChildOrder := 1;
    pnlNavigator.Color := clSilver;
    pnlNavigator.TabOrder := 1;
    WebSpeedButton1.SetParentComponent(pnlNavigator);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 8;
    WebSpeedButton1.Top := 5;
    WebSpeedButton1.Width := 45;
    WebSpeedButton1.Height := 45;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(pnlNavigator);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 56;
    WebSpeedButton2.Top := 5;
    WebSpeedButton2.Width := 45;
    WebSpeedButton2.Height := 45;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(pnlNavigator);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 104;
    WebSpeedButton3.Top := 5;
    WebSpeedButton3.Width := 45;
    WebSpeedButton3.Height := 45;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(pnlNavigator);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 152;
    WebSpeedButton4.Top := 5;
    WebSpeedButton4.Width := 45;
    WebSpeedButton4.Height := 45;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(pnlNavigator);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 200;
    WebSpeedButton5.Top := 5;
    WebSpeedButton5.Width := 45;
    WebSpeedButton5.Height := 45;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebPanel2.SetParentComponent(pnlAttendants);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 420;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alBottom;
    WebPanel2.ChildOrder := 2;
    WebPanel2.Color := clSilver;
    WebPanel2.TabOrder := 2;
    WebButton1.SetParentComponent(WebPanel2);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 8;
    WebButton1.Top := 17;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Close';
    WebButton1.Color := clRed;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    sbtnPCFirst.SetParentComponent(WebPanel2);
    sbtnPCFirst.Name := 'sbtnPCFirst';
    sbtnPCFirst.Left := 122;
    sbtnPCFirst.Top := 16;
    sbtnPCFirst.Width := 24;
    sbtnPCFirst.Height := 24;
    sbtnPCFirst.Caption := '<<';
    sbtnPCFirst.Color := clNone;
    sbtnPCFirst.HeightPercent := 100.000000000000000000;
    sbtnPCFirst.TabOrder := 1;
    sbtnPCFirst.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnPCFirst, Self, 'OnClick', 'sbtnPCFirstClick');
    sbtnPCPrior.SetParentComponent(WebPanel2);
    sbtnPCPrior.Name := 'sbtnPCPrior';
    sbtnPCPrior.Left := 144;
    sbtnPCPrior.Top := 16;
    sbtnPCPrior.Width := 24;
    sbtnPCPrior.Height := 24;
    sbtnPCPrior.Caption := '<';
    sbtnPCPrior.Color := clNone;
    sbtnPCPrior.HeightPercent := 100.000000000000000000;
    sbtnPCPrior.TabOrder := 2;
    sbtnPCPrior.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnPCPrior, Self, 'OnClick', 'sbtnPCPriorClick');
    sbtnPCNext.SetParentComponent(WebPanel2);
    sbtnPCNext.Name := 'sbtnPCNext';
    sbtnPCNext.Left := 211;
    sbtnPCNext.Top := 16;
    sbtnPCNext.Width := 24;
    sbtnPCNext.Height := 24;
    sbtnPCNext.Caption := '>';
    sbtnPCNext.Color := clNone;
    sbtnPCNext.HeightPercent := 100.000000000000000000;
    sbtnPCNext.TabOrder := 3;
    sbtnPCNext.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnPCNext, Self, 'OnClick', 'sbtnPCNextClick');
    sbtnPCLast.SetParentComponent(WebPanel2);
    sbtnPCLast.Name := 'sbtnPCLast';
    sbtnPCLast.Left := 234;
    sbtnPCLast.Top := 16;
    sbtnPCLast.Width := 24;
    sbtnPCLast.Height := 24;
    sbtnPCLast.Caption := '>>';
    sbtnPCLast.Color := clNone;
    sbtnPCLast.HeightPercent := 100.000000000000000000;
    sbtnPCLast.TabOrder := 4;
    sbtnPCLast.WidthPercent := 100.000000000000000000;
    SetEvent(sbtnPCLast, Self, 'OnClick', 'sbtnPCLastClick');
    edtAttendantPC.SetParentComponent(WebPanel2);
    edtAttendantPC.Name := 'edtAttendantPC';
    edtAttendantPC.Left := 167;
    edtAttendantPC.Top := 16;
    edtAttendantPC.Width := 45;
    edtAttendantPC.Height := 24;
    edtAttendantPC.AutoSize := False;
    edtAttendantPC.TabOrder := 5;
    edtAttendantPC.Text := '';
    edtAttendantPC.Lookup.Separator := ';';
    dgAttendants.SetParentComponent(pnlAttendants);
    dgAttendants.Name := 'dgAttendants';
    dgAttendants.Left := 0;
    dgAttendants.Top := 115;
    dgAttendants.Width := 640;
    dgAttendants.Height := 305;
    dgAttendants.Align := alClient;
    dgAttendants.ParentDoubleBuffered := False;
    dgAttendants.DoubleBuffered := True;
    dgAttendants.TabOrder := 3;
    dgAttendants.ShowAcceleratorChar := False;
    dgAttendants.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgAttendants.Header.VisualGrouping.Layout.Font.Height := -12;
    dgAttendants.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgAttendants.Header.VisualGrouping.Layout.Font.Style := [];
    dgAttendants.Adapter := dbaFuelAttendants;
    dgAttendants.BitmapContainer := BitmapContainer;
    dgAttendants.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgAttendants.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgAttendants.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgAttendants.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgAttendants.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.BandLayout.Font.Height := -12;
    dgAttendants.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.BandLayout.Font.Style := [];
    dgAttendants.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.FixedLayout.Font.Height := -12;
    dgAttendants.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.FixedLayout.Font.Style := [];
    dgAttendants.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgAttendants.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgAttendants.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.FocusedLayout.Font.Height := -12;
    dgAttendants.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.FocusedLayout.Font.Style := [];
    dgAttendants.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.GroupLayout.Font.Height := -12;
    dgAttendants.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.GroupLayout.Font.Style := [];
    dgAttendants.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.NormalLayout.Font.Height := -12;
    dgAttendants.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.NormalLayout.Font.Style := [];
    dgAttendants.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.SelectedLayout.Font.Height := -12;
    dgAttendants.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.SelectedLayout.Font.Style := [];
    dgAttendants.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgAttendants.CellAppearance.SummaryLayout.Font.Height := -12;
    dgAttendants.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgAttendants.CellAppearance.SummaryLayout.Font.Style := [];
    dgAttendants.ColumnCount := 6;
    dgAttendants.Columns.Clear;
    with dgAttendants.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'AttNo';
    end;
    with dgAttendants.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    with dgAttendants.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Password';
    end;
    with dgAttendants.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Suspended';
    end;
    with dgAttendants.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType];
    end;
    with dgAttendants.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType];
    end;
    dgAttendants.Designer := False;
    dgAttendants.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgAttendants.FilterAppearance.Font.Color := clWindowText;
    dgAttendants.FilterAppearance.Font.Height := -12;
    dgAttendants.FilterAppearance.Font.Name := 'Segoe UI';
    dgAttendants.FilterAppearance.Font.Style := [];
    dgAttendants.Icons.ExpandIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.ExpandIcon.svg');
    dgAttendants.Icons.CollapseIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.CollapseIcon.svg');
    dgAttendants.Icons.FilterIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.FilterIcon.svg');
    dgAttendants.Icons.FilterActiveIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.FilterActiveIcon.svg');
    dgAttendants.Icons.FilterClearIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.FilterClearIcon.svg');
    dgAttendants.Icons.FilterTypeIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.FilterTypeIcon.svg');
    dgAttendants.Icons.SortAscendingIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.SortAscendingIcon.svg');
    dgAttendants.Icons.SortDescendingIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.SortDescendingIcon.svg');
    dgAttendants.Icons.CloseIcon.LoadFromFile('DieselAttendants.pnlAttendants.dgAttendants.Icons.CloseIcon.svg');
    SetEvent(dgAttendants, Self, 'OnCellClick', 'dgAttendantsCellClick');
    SetEvent(dgAttendants, Self, 'OnGetCellProperties', 'dgAttendantsGetCellProperties');
    dgAttendants.RowCount := 1;
    dbaFuelAttendants.SetParentComponent(dgAttendants);
    dbaFuelAttendants.Name := 'dbaFuelAttendants';
    dbaFuelAttendants.Left := 600;
    dbaFuelAttendants.Top := 14;
    dbaFuelAttendants.Width := 26;
    dbaFuelAttendants.Height := 26;
    dbaFuelAttendants.Visible := True;
    dbaFuelAttendants.AutoCreateColumns := False;
    dbaFuelAttendants.AutoRemoveColumns := False;
    dbaFuelAttendants.Columns.Clear;
    with dbaFuelAttendants.Columns.Add do
    begin
      FieldName := 'ATTNO';
      Header := 'AttNo';
      AutoCreated := False;
    end;
    with dbaFuelAttendants.Columns.Add do
    begin
      FieldName := 'NAME';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dbaFuelAttendants.Columns.Add do
    begin
      FieldName := 'password';
      Header := 'Password';
      AutoCreated := False;
    end;
    with dbaFuelAttendants.Columns.Add do
    begin
      FieldName := 'SUSPENDED';
      Header := 'Suspended';
      AutoCreated := False;
    end;
    with dbaFuelAttendants.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dbaFuelAttendants.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dbaFuelAttendants.DataSource := dsFuelAttendants;
    wcFuelAttendants.SetParentComponent(Self);
    wcFuelAttendants.Name := 'wcFuelAttendants';
    wcFuelAttendants.Connection := dmData.dbConnect;
    wcFuelAttendants.Left := 24;
    wcFuelAttendants.Top := 121;
    wdsFuelAttendants.SetParentComponent(Self);
    wdsFuelAttendants.Name := 'wdsFuelAttendants';
    wdsFuelAttendants.Connection := dmData.dbConnect;
    wdsFuelAttendants.Left := 96;
    wdsFuelAttendants.Top := 121;
    wdsFuelAttendantsATTNO.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantsATTNO.Name := 'wdsFuelAttendantsATTNO';
    wdsFuelAttendantsATTNO.FieldName := 'ATTNO';
    wdsFuelAttendantsNAME.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantsNAME.Name := 'wdsFuelAttendantsNAME';
    wdsFuelAttendantsNAME.FieldName := 'NAME';
    wdsFuelAttendantspassword.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantspassword.Name := 'wdsFuelAttendantspassword';
    wdsFuelAttendantspassword.FieldName := 'password';
    wdsFuelAttendantsSUSPENDED.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantsSUSPENDED.Name := 'wdsFuelAttendantsSUSPENDED';
    wdsFuelAttendantsSUSPENDED.FieldName := 'SUSPENDED';
    dsFuelAttendants.SetParentComponent(Self);
    dsFuelAttendants.Name := 'dsFuelAttendants';
    dsFuelAttendants.DataSet := wdsFuelAttendants;
    dsFuelAttendants.Left := 176;
    dsFuelAttendants.Top := 121;
  finally
    pnlAttendants.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    BitmapContainer.AfterLoadDFMValues;
    msgdlgFuelAttendants.AfterLoadDFMValues;
    pnlNavigator.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    sbtnPCFirst.AfterLoadDFMValues;
    sbtnPCPrior.AfterLoadDFMValues;
    sbtnPCNext.AfterLoadDFMValues;
    sbtnPCLast.AfterLoadDFMValues;
    edtAttendantPC.AfterLoadDFMValues;
    dgAttendants.AfterLoadDFMValues;
    dbaFuelAttendants.AfterLoadDFMValues;
    wcFuelAttendants.AfterLoadDFMValues;
    wdsFuelAttendants.AfterLoadDFMValues;
    wdsFuelAttendantsATTNO.AfterLoadDFMValues;
    wdsFuelAttendantsNAME.AfterLoadDFMValues;
    wdsFuelAttendantspassword.AfterLoadDFMValues;
    wdsFuelAttendantsSUSPENDED.AfterLoadDFMValues;
    dsFuelAttendants.AfterLoadDFMValues;
  end;
end;

end.
